module.exports = "<div class=\"main-left-column\" [@slide]=\"activePane\" [class.hide-left-column]=\"showSubmenu === false\">\n    \n    <app-main-navigation select=\"[leftPane]\" [lang]=\"lang\" [typeId]=\"typeId\" [subtypeId]=\"subtypeId\" class=\"left-pane\"></app-main-navigation>\n\n    <app-sub-navigation-container *ngIf=\"showSubmenu\" select=\"[rightPane]\" [lang]=\"lang\" [typeId]=\"typeId\" [subtypeId]=\"subtypeId\" class=\"right-pane\"></app-sub-navigation-container>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/main-left-column/main-left-column.component.html
// module id = ./src/app/main-left-column/main-left-column.component.html
// module chunks = main